import Swiper from 'swiper/bundle'
import { debounce } from '../utils/_debounce'
import SimpleLightbox from 'simplelightbox'

var $ = jQuery

export default class GalleryWidgets {
  	ready () {
		const GALLERY_WIDGETS = document.querySelectorAll('.mtt-gallery-widget');
		if (GALLERY_WIDGETS.length > 0) {
			for (let i = 0; i < GALLERY_WIDGETS.length; i++) {
				new GalleryWidget(GALLERY_WIDGETS[i]);
			}
		}
	}
}

class GalleryWidget {

	constructor(CONTAINER) {
		this.CONTAINER = CONTAINER;
		this.SWIPER_CONTAINER = this.CONTAINER.querySelector('.swiper-container');

		if (!this.SWIPER_CONTAINER) {
			return;
		}

		this.SWIPER = new Swiper(this.SWIPER_CONTAINER, {
			containerModifierClass: 'swiper-container-',
			slidesPerView: 1.1,
			speed: 800,
			spaceBetween: 24,
			freeMode: false,
			watchOverflow: true,
			navigation: {
				addIcons: false,
				nextEl: this.CONTAINER.querySelector('.swiper-button-next'),
				prevEl: this.CONTAINER.querySelector('.swiper-button-prev')
			},
			breakpoints: {
				401: {
                    slidesPerView: 1.2
                },
				1001: {
					slidesPerView: 1.6
				}
			},
			observer: true,
			observeParents: true,
		});

		this.updateSlidesOffset();
		this.SWIPER.on('resize', debounce(() => this.updateSlidesOffset(), 300));

		// create lightbox
		this.addLightbox();
	}

	// calculate slidesOffsetAfter for swiper
	updateSlidesOffset() {

		// get elements
		const GALLERY_CONTAINER = this.CONTAINER.querySelector('.mtt-gallery-widget__slider .page_container');
		const LAST_SLIDE = this.CONTAINER.querySelector('.mtt-gallery-widget__slider .last-slide');

		let slidesOffsetAfter = 0;

		if (GALLERY_CONTAINER && LAST_SLIDE) {

			// get widths
			const GALLERY_CONTAINER_WIDTH = GALLERY_CONTAINER.getBoundingClientRect().width;
			const LAST_SLIDE_WIDTH = LAST_SLIDE.getBoundingClientRect().width;

			// calculate offset
			slidesOffsetAfter = GALLERY_CONTAINER_WIDTH - LAST_SLIDE_WIDTH;

			this.SWIPER.wrapperEl.style.paddingRight = `${Math.max(0, slidesOffsetAfter + 1)}px`;
			this.SWIPER.params.initialSlide = 0;
			this.SWIPER.update();
		}
	}

	addLightbox () {
		let containers = Array.from($(this.CONTAINER).find('.mtt-gallery-widget-slide__expand'))
		let lightbox = new SimpleLightbox(containers, {
			history: false,
			doubleTapZoom: 1
		})

		lightbox.on('show.simplelightbox', function () {
			$(this).find('.mtt-gallery-widget-slide__expand').css('pointer-events', 'none')
		})

		lightbox.on('shown.simplelightbox', function () {
			$(this).find('.sl-overlay').css('pointer-events', 'all')
			$(this).find('.sl-wrapper').css('pointer-events', 'all')
		})

		lightbox.on('close.simplelightbox', function () {
			$(this).find('.mtt-gallery-widget-slide__expand').css('pointer-events', 'all')
			$(this).find('.sl-overlay').css('pointer-events', 'none')
			$(this).find('.sl-wrapper').css('pointer-events', 'none')
		})
	}
}
